import React, { useState } from 'react'
import axios from 'axios'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'
import FeederDosingModeForm from './FeederDosingModeForm'

const emptyDosingMode = {
  name: '',
  dosing_para_fast: {
    id: null,
    pressure: 0,
    frequency: 0,
    duty_cycle: 0
  },
  dosing_para_slow: {
    id: null,
    pressure: 0,
    frequency: 0,
    duty_cycle: 0
  },
}

const FeederDosingModePage = ({ feederDosingMode: initialDosingMode }) => {

  const [dosingMode, setDosingMode] = useState(initialDosingMode || emptyDosingMode)
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const handleSubmit = (submittedDosingMode, onFinished) => {
    const { dosing_para_fast, dosing_para_slow, ...dosingMode } = submittedDosingMode
    const body = {feeder_dosing_mode: {
      ...dosingMode,
      dosing_para_fast_attributes: {...dosing_para_fast, mode_type: 'fast'},
      dosing_para_slow_attributes: {...dosing_para_slow, mode_type: 'slow'},
    }}

    const request = !!dosingMode.id ? updateFeederDosingModeRequest(dosingMode.id, body) : createFeederDosingModeRequest(body)

    request
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'feeder_dosing_modes' }))
        onFinished(true, null)
        setDosingMode(resp.data)
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'feeder_dosing_modes' }))
        onFinished(false, error.response.data)
      })
  }

  const createFeederDosingModeRequest = (feederDosingMode) => {
    return axios.post('/admin/feeder_dosing_modes', feederDosingMode)
  }

  const updateFeederDosingModeRequest = (id, feederDosingMode) => {
    return axios.put(`/admin/feeder_dosing_modes/${id}`, feederDosingMode)
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={[!!dosingMode.id ? 'Edit' : 'New', t('feeder_dosing_modes.feeder_dosing_mode')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <FeederDosingModeForm
              dosingMode={dosingMode}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default FeederDosingModePage
